export default "__VITE_ASSET__BmN30Nwa__"